import { Group, Icon, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useStore, useToast, useModal, usePage } from "@/comn/hooks";
import { URLS, APIS, SF_BLTBRD_MGMT } from "@/tra/tancis/ptli/ptl/bltbrd/services/PtlibltbrdService";
import { useRef, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PTLI1017004Q } from "./PTLI1017004Q";
import { PTLI1017005Q } from "./PTLI1017005Q";

/*
 * Register for Bulletin board Management
 * !== 게시판 관리 등록 ==!
 */
export const PTLI1017002S = (): JSX.Element => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const [tpCdValues, setTpCdValues] = useState<tpCd[]>([]);
    const [relaBltbrds, setRelaBltbrds] = useState<relaBltbrd[]>([]);
    const [stateMgmt, setStateMgmt] = useState<stateMgmt>({
        btbdrpUseYn: false,
        atcmUseYn: false,
        btbdmsTpCdUseYn: false,
        relaBltbrdUseYn: false,
    });

    interface tpCd {
        btbdmsTpCd: string;
        btbdmsTpCdNm: string;
    }

    interface relaBltbrd {
        relaBltbrdId: string;
        relaBltbrdNm: string;
    }

    interface stateMgmt {
        btbdrpUseYn: Boolean;
        atcmUseYn: Boolean;
        btbdmsTpCdUseYn: Boolean;
        relaBltbrdUseYn: Boolean;
    }

    const TpCdCtrl = () => {
        return (
            <>
                <Group.Col colSize={9}>
                    {tpCdValues.map((obj, index) => (
                        <div key={obj.btbdmsTpCd} className="flex">
                            <input
                                className={"input rounded-r-none flex-1"}
                                value={tpCdValues.find((item) => item.btbdmsTpCd === obj.btbdmsTpCd)?.btbdmsTpCd}
                                onChange={() => {}}
                            />
                            <input
                                readOnly={true}
                                className={"input rounded-l-none flex-[2]"}
                                value={tpCdValues.find((item) => item.btbdmsTpCd === obj.btbdmsTpCd)?.btbdmsTpCdNm}
                                onChange={() => {}}
                            />
                        </div>
                    ))}
                </Group.Col>
            </>
        );
    };

    const RelaBltCtrl = () => {
        return (
            <>
                <Group.Col colSize={9}>
                    {relaBltbrds.map((obj, index) => (
                        <div key={obj.relaBltbrdId} className="flex">
                            <input
                                className={"input rounded-r-none flex-[2]"}
                                value={relaBltbrds.find((item) => item.relaBltbrdId === obj.relaBltbrdId)?.relaBltbrdId}
                                onChange={() => {}}
                            />
                            <input
                                className={"input rounded-l-none flex-1"}
                                readOnly={true}
                                value={relaBltbrds.find((item) => item.relaBltbrdId === obj.relaBltbrdId)?.relaBltbrdNm}
                                onChange={() => {}}
                            />
                        </div>
                    ))}
                </Group.Col>
            </>
        );
    };

    const form = {
        bltbrd: useForm({
            defaultSchema: SF_BLTBRD_MGMT,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const fetch = {
        // Save Bulletin board Management Information !== 게시판 관리 정보 등록 ==!
        registBltbrdInfo: useFetch({
            api: () =>
                APIS.registBltbrdInfo({
                    ...form.bltbrd.getValues(),
                    bltbrdTpCdList: tpCdValues,
                    reLaBltbrdList: relaBltbrds,
                }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003", // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                    onCancel: () => {
                        navigate(`${URLS.ptli1017001q}?menuId=${menuId}`);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.ptli1017001q}?menuId=${menuId}`),

        stateMgmtValueChange: (type: string) => {
            const value = form.bltbrd.getValue(type);
            setStateMgmt((prevState) => ({
                ...prevState,
                [type]: value === "Y",
            }));
        },

        onSubmitBtnClick: form.bltbrd.handleSubmit(
            () => {
                modal.openModal({
                    content: "msg.com.00047", // Confirm save? !== 저장하시겠습니까? ==!
                    onConfirm: () => fetch.registBltbrdInfo.fetch(),
                });
            },
            (err) => {
                form.bltbrd.setFocus(err[0]);
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid !== 데이터가 유효하지 않습니다. ==!
            },
        ),

        clickTpCdSel: () => {
            const modalCallback = (data: any) => {
                if (data) {
                    modal.closeModal();
                }
                const lang = localStorage.getItem("lang");
                const newChildValues = data.tpCdList.map((obj: any) => {
                    let btbdmsTpCdNm = "";
                    if (lang === "ko") {
                        btbdmsTpCdNm = obj.btbdmsTpCdKoNm;
                    } else if (lang === "en") {
                        btbdmsTpCdNm = obj.btbdmsTpCdEnNm;
                    } else if (lang === "tz") {
                        btbdmsTpCdNm = obj.btbdmsTpCdTzNm;
                    }
                    return {
                        btbdmsTpCd: obj.btbdmsTpCd,
                        btbdmsTpCdNm: btbdmsTpCdNm,
                    };
                });
                setTpCdValues(newChildValues);
            };

            modal.openModal({
                size: "md",
                draggable: true,
                content: <PTLI1017004Q params={tpCdValues} callback={modalCallback} />,
            });
        },

        clickRelaBltbrdSel: () => {
            const modalCallback = (data: any) => {
                if (data) {
                    modal.closeModal();
                }
                const lang = localStorage.getItem("lang");
                const newChildValues = data.relaBltbrdList.map((obj: any) => {
                    let bltbrdNm = "";
                    if (lang === "ko") {
                        bltbrdNm = obj.bltbrdKoNm;
                    } else if (lang === "en") {
                        bltbrdNm = obj.bltbrdEngNm;
                    } else if (lang === "tz") {
                        bltbrdNm = obj.bltbrdTzNm;
                    }
                    return {
                        relaBltbrdId: obj.bltbrdUuId,
                        relaBltbrdNm: bltbrdNm,
                    };
                });
                setRelaBltbrds(newChildValues);
            };
            modal.openModal({
                size: "md",
                draggable: true,
                content: <PTLI1017005Q params={relaBltbrds} callback={modalCallback} />,
            });
        },
    };

    useEffect(() => {
        form.bltbrd.setEditable(true);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Title title={t("L_GEN_SET")} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bltbrd.schema.useYn} />
                            <Group.Control {...form.bltbrd.schema.btbdmsSelcExuseYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bltbrd.schema.bltbrdEngNm} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bltbrd.schema.bltbrdTzNm} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bltbrd.schema.bltbrdKoNm} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bltbrd.schema.ppupSettPsblYn} />
                            <Group.Control {...form.bltbrd.schema.selcCntUseYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bltbrd.schema.secrtBtbdmsUseYn} />
                            <Group.Control {...form.bltbrd.schema.btbdcmUseYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bltbrd.schema.chgYn} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Title title={t("L_RP_SET")} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.bltbrd.schema.btbdrpUseYn}
                                onChange={() => {
                                    handler.stateMgmtValueChange("btbdrpUseYn");
                                }}
                            />
                            <Group.Control
                                {...form.bltbrd.schema.btbdrpSelcExuseYn}
                                readOnly={!stateMgmt.btbdrpUseYn}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.bltbrd.schema.btbdrpSttsUseYn}
                                message={t("msg.ptl.00701")}
                                readOnly={!stateMgmt.btbdrpUseYn}
                            />
                            <Group.Control
                                {...form.bltbrd.schema.btbdrpBtbdcmUseYn}
                                readOnly={!stateMgmt.btbdrpUseYn}
                            />
                        </Group.Row>
                    </Group.Section>

                    <Group.Title title={t("L_ATCM_SET")} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.bltbrd.schema.atcmUseYn}
                                onChange={() => {
                                    handler.stateMgmtValueChange("atcmUseYn");
                                }}
                            />
                            <Group.Control
                                {...form.bltbrd.schema.atcmUpldLmtNo}
                                controlSize={1}
                                readOnly={!stateMgmt.atcmUseYn}
                            />
                            <Group.Col colSize={2}></Group.Col>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bltbrd.schema.atcmCapcLmtYn} readOnly={!stateMgmt.atcmUseYn} />
                            <Group.Control
                                {...form.bltbrd.schema.atcmLmtCapc}
                                controlSize={1}
                                maxLength={5}
                                readOnly={!stateMgmt.atcmUseYn}
                            />
                            <Group.Col colSize={2}>MB</Group.Col>
                        </Group.Row>
                    </Group.Section>

                    <Group.Title title={t("L_TP_CD_SET")} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.bltbrd.schema.btbdmsTpCdUseYn}
                                controlSize={1}
                                onChange={() => {
                                    handler.stateMgmtValueChange("btbdmsTpCdUseYn");
                                }}
                            />
                            <Group.Col>
                                {stateMgmt.btbdmsTpCdUseYn && (
                                    <button
                                        data-color="blue"
                                        type="button"
                                        onClick={handler.clickTpCdSel}
                                        className="max-w-full min-w-max flex justify-center items-center disabled:bg-uf-lightgray disabled:border-uf-lightgray disabled:pointer-events-none uf-button-outlined blue"
                                    >
                                        {t("B_TP_CD_SEL")}
                                    </button>
                                )}
                            </Group.Col>
                        </Group.Row>
                        <Group.Row>
                            <Group.Label label={t("L_BTBDMS_TP_CD")}></Group.Label>
                            {stateMgmt.btbdmsTpCdUseYn && <TpCdCtrl />}
                        </Group.Row>
                    </Group.Section>

                    <Group.Title title={t("L_RELA_BLTBRD_SET")} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.bltbrd.schema.relaBltbrdUseYn}
                                controlSize={1}
                                onChange={() => {
                                    handler.stateMgmtValueChange("relaBltbrdUseYn");
                                }}
                            />
                            <Group.Col>
                                {stateMgmt.relaBltbrdUseYn && (
                                    <button
                                        data-color="blue"
                                        type="button"
                                        onClick={handler.clickRelaBltbrdSel}
                                        className="max-w-full min-w-max flex justify-center items-center disabled:bg-uf-lightgray disabled:border-uf-lightgray disabled:pointer-events-none uf-button-outlined blue"
                                    >
                                        {t("B_RELA_BLTBRD_SEL")}
                                    </button>
                                )}
                            </Group.Col>
                        </Group.Row>
                        <Group.Row>
                            <Group.Label label={t("L_RELA_BLTBRD_ID")}></Group.Label>
                            {stateMgmt.relaBltbrdUseYn && <RelaBltCtrl />}
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={() => handler.onListBtnClick()} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"submit"} onClick={() => handler.onSubmitBtnClick()} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
